let promiseResolve;
const rawBlackboxPromise = new Promise((resolve) => {
  promiseResolve = resolve;
});

const getBlackboxPromise = (timeout) => Promise.race([
  rawBlackboxPromise,
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(window.IGLOO.getBlackbox().blackbox);
    }, timeout);
  }),
]);

window.IGLOO = window.IGLOO || {
  enable_flash: false,
  bb_callback:  (bb, complete) => {
    if (complete) { promiseResolve(bb); }
  },
  loader: {
    fp_dyn:   false,
    uri_hook: 'iojs',
    version:  'general5',
    subkey:   '5FExse+oA1134BhiwCF2EeQ1TfisPJGha4CpVG2nd7E=',
  },
};

/* iovation javascript */
require('./loader_static5_2_2');

export default getBlackboxPromise;
